const utils = {
  toDB: v => {
    let files = [];
    files = files.concat(v.modelPhotoDesktop);
    files = files.concat(v.modelPhotoMobile);
    files.push(v.watermarkDesktop);
    files.push(v.watermarkMobile);
    files.push(v.backgroundDesktop);
    files.push(v.backgroundMobile);
    return {
      id: v.id,
      domain: v.domain,
      customerId: v.customerId,
      layout: v.layout,
      resolutionDesktop: v.resolutionDesktop,
      resolutionMobile: v.resolutionMobile,
      files: files,
      attrs: v.attrs,
    };
  },
  fromDB: v => {
    return v === null
      ? {}
      : {
          id: v.id,
          domain: v.domain,
          customerId: v.customerId,
          layout: v.layout,
          resolutionDesktop: v.resolutionDesktop,
          resolutionMobile: v.resolutionMobile,
          sdkVersion: v.sdkVersion,
          modelPhotoDesktop: utils.findFilesFromDB(
            v.files,
            'DESKTOP',
            'MODEL',
            true
          ),
          modelPhotoMobile: utils.findFilesFromDB(
            v.files,
            'MOBILE',
            'MODEL',
            true
          ),
          watermarkDesktop: utils.findFilesFromDB(
            v.files,
            'DESKTOP',
            'WATERMARK',
            false
          ),
          watermarkMobile: utils.findFilesFromDB(
            v.files,
            'MOBILE',
            'WATERMARK',
            false
          ),
          backgroundDesktop: utils.findFilesFromDB(
            v.files,
            'DESKTOP',
            'BACKGROUND',
            false
          ),
          backgroundMobile: utils.findFilesFromDB(
            v.files,
            'MOBILE',
            'BACKGROUND',
            false
          ),
          createdTime: v.createdTime,
          lastModified: v.lastModified,
          attrs: utils.attrsFromDB(v.attrs),
        };
  },

  findFilesFromDB: (files, platform, fileType, isArray) => {
    if (files === undefined) {
      return [];
    }
    let result = files.filter(function(f) {
      return f.platform === platform && f.fileType === fileType;
    });
    if (!isArray) {
      return result.length > 0 ? result[0] : {};
    }
    return result;
  },
  attrsFromDB: attrs => {
    const updatedAttrs = {};
    Object.keys(attrs).forEach(function (key) {
      if (key === 'layout-language' || key === 'enabled-categories') {
        updatedAttrs[key] = attrs[key];
      } else {
        updatedAttrs[key] = attrs[key] === 'true';
      }
    });
    return updatedAttrs;
  },
  credential: {
    fromDB: v => ({
      id: v.id,
      createdTime: v.createdTime,
      lastModified: v.lastModified,
      apiKey: v.apiKey,
    }),
  },
};
export default utils;
